import { HairLength } from '@drycut/graphql';
import { ToggleButtonGroup } from '@drycut/ui-components';
import { Controller } from 'react-hook-form';

type Props = {
  name: string;
};

export default function ControlledHairLengthToggle({ name }: Props): React.ReactElement {
  return (
    <Controller
      name={name}
      render={({ field: { onChange, value } }) => (
        <ToggleButtonGroup
          onChange={onChange}
          options={[
            { label: 'Kurzhaar', value: HairLength.Short },
            { label: 'Langhaar', value: HairLength.Long },
          ]}
          selected={value}
        />
      )}
    />
  );
}
